import React, { forwardRef } from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { useShouldRender } from '../../utils/useShouldRender.esm.js';

const defaultStyle = {
    minWidth: "8.5rem",
    maxHeight: "17rem",
};
/**
 * Displays a list of elements to the user.
 *
 * This component is rarely used directly. Usually, a Select or MultiSelect component
 * will meet your needs. But, when that isn't the case, use the List to display a menu
 * of options to the user.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { List, ListItem } from "@panwds/react-ui";
 * ```
 *
 */
const List = forwardRef(({ children, dataMetrics, dataTestId, isOpen = true, style = {}, ...passThrough }, ref) => {
    const shouldRender = useShouldRender(isOpen);
    const mergedStyle = shouldRender
        ? { ...defaultStyle, ...style }
        : defaultStyle;
    const className = classNames("tw-box-border tw-m-0 tw-p-0 tw-font-lato tw-border tw-border-solid tw-border-gray-300 tw-rounded tw-overflow-auto tw-scrollbar-small dark:tw-scrollbar-track-dark dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark focus:tw-outline-none tw-shadow-popover dark:tw-shadow-dark-popover tw-transition-opacity tw-duration-200", "tw-text-default dark:tw-text-gray-100", shouldRender && "tw-border dark:tw-border-gray-950", !isOpen && "tw-opacity-0");
    return (React.createElement("ul", { "data-metrics": dataMetrics, "data-testid": dataTestId || "unordered-list", className: className, style: mergedStyle, ...passThrough, ref: ref }, shouldRender && children));
});
List.displayName = "List";

export { List };
//# sourceMappingURL=List.esm.js.map
